import type { FaireProductEntity } from "../../entity_types/product";

export const p_9h9vr3hj3w: FaireProductEntity = {
  token: "p_9h9vr3hj3w",
  type: "product",
  name: "Ornament Frame Only with Ribbon",
  brandName: "French Graffiti",
  imageUrl:
    "https://cdn.faire.com/fastly/cf0308608ff3775689e65261d13b9846b55e1270326d8036976231280cf1d157.jpeg",
  priceDollars: 7.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/da6eedba38d978791085955595955d0acc0b3a1d23c656c60216928be74d7e8a.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
